import { siteStats } from '@/mocks/gossip';

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20stage%20with%20glowing%20red%20and%20amber%20spotlights%20cutting%20through%20smoke%2C%20floating%20particles%20and%20lens%20flare%20in%20the%20air%2C%20stylized%20abstract%20award%20ceremony%20atmosphere%2C%20cinematic%20moody%20lighting%2C%20deep%20shadows%2C%20high%20contrast%2C%20no%20people%2C%20no%20text%2C%20luxury%20editorial%20background&width=1920&height=1080&seq=gossip-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 py-24 md:py-28">
        <div className="max-w-4xl mx-auto text-center animate-fadeUp">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs md:text-sm font-label mb-5">
            <i className="ri-flashlight-fill animate-softPulse" aria-hidden="true"></i>
            今日爆料实时更新 · 独家猛料抢先看
          </span>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 leading-tight mb-5">
            黑料吃瓜网
            <span className="block mt-2 text-accent-400 text-2xl md:text-4xl lg:text-5xl">
              最新黑料 · 今日爆料 · 独家合集
            </span>
          </h1>

          <p className="text-background-100/90 text-sm md:text-base lg:text-lg leading-relaxed max-w-2xl mx-auto mb-8 font-body">
            汇集黑料吃瓜网最新黑料与今日爆料，覆盖明星、网红等独家黑料合集。
            我们用清晰的脉络帮你理清事件来龙去脉，快速了解一手八卦资讯，
            做一个理性、有判断力的吃瓜群众。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-12">
            <a
              href="#latest"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-label whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-article-line" aria-hidden="true"></i>
              立即查看最新黑料
            </a>
            <a
              href="#ranking"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-foreground-950 text-sm md:text-base font-label whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
            >
              <i className="ri-bar-chart-grouped-line" aria-hidden="true"></i>
              看今日吃瓜热度榜
            </a>
          </div>

          <dl className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 max-w-3xl mx-auto">
            {siteStats.map((stat) => (
              <div
                key={stat.id}
                className="px-3 py-4 rounded-lg bg-white/10 backdrop-blur-sm border border-white/15"
              >
                <dt className="text-[11px] md:text-xs text-background-100/80 mb-1 font-label">{stat.label}</dt>
                <dd className="font-heading text-2xl md:text-3xl text-accent-400">{stat.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}